module.exports = __webpack_public_path__ + "img/vlcsnap-2016-03-22-13h37m10s987.6eac88f7.png";